<template>
  <FlexCol gap-1>
    <Label :label="label" :required="required" :error="error" v-if="label" />
    <InputArc :disabled="disabled" :error="error">
      <template #input>
        <input
          v-model="displayValue"
          :disabled="disabled"
          :placeholder="placeholder"
          :type="type || 'text'"
          :autocomplete="autocomplete"
          :name="name"
          @input="handleInput"
          class="w-full bg-transparent focus:outline-none focus:ring-0 placeholder:italic" />
      </template>
    </InputArc>
    <Error :message="error" v-if="error" />
  </FlexCol>
</template>

<script setup>
import { watch, ref } from 'vue'
import { useUtils } from '@/composables/useUtils'

const { applyMask } = useUtils()

const props = defineProps({
  label: String,
  required: Boolean,
  disabled: Boolean,
  error: Array,
  modelValue: [String, Number],
  placeholder: String,
  mask: String,
  type: String,
  autocomplete: String,
  name: String,
})

const emits = defineEmits(['update:modelValue'])
const localValue = ref(props.modelValue)
const displayValue = ref(applyMask(localValue.value, props.mask))
const error = ref(props.error)

const handleInput = (event) => {
  let val = event.target.value
  displayValue.value = applyMask(val, props.mask)
}

watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
    displayValue.value = applyMask(newValue, props.mask)
  },
)

watch(
  () => props.error,
  (newValue) => {
    error.value = newValue
  },
)

watch(displayValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
